import {
  Typography,
  Container,
  Box,
  Button,
  useTheme,
  Link,
} from '@mui/material';
import { styled } from '@mui/system';
import { useConfig } from '../../../Hooks/useConfig';

const ImageWarning = styled('img')(({ theme }) => ({
  width: theme.spacing(43),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(30),
  },
}));

const CustomerSupportLink = styled(Link)(({ theme }) => ({
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.secondary_70
      : theme.palette.secondary.main,
  fontSize: '16px',

  [theme.breakpoints.up('xl')]: {
    fontSize: '24px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}));

const LayoutStatusPageText = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode !== 'dark' ? 'rgba(0, 0, 0, 0.87)' : '#fff',
  textAlign: 'center',
  lineHeight: 2,
  width: '100%',
  fontSize: '16px',
  padding: `0 ${theme.spacing(2)}`,
  [theme.breakpoints.up('xl')]: {
    fontSize: '24px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}));

const LayoutStatusPageTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode !== 'dark' ? 'rgba(0, 0, 0, 0.87)' : '#fff',
  padding: `0 ${theme.spacing(1.5)}`,
  fontSize: '18px',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('xl')]: {
    fontSize: '24px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '24px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
}));

const LayoutStatusPageBox = styled(Box)(({ theme }) => ({
  height: '80%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: theme.palette.mode !== 'dark' ? '#fff' : '#252525',
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(20),
  },
}));

const BackHomeButton = styled(Button)(({ theme }) => ({
  fontSize: theme.spacing(4),
  fontWeight: 600,
  padding: theme.spacing(3, 22),
  color: theme.palette.mode !== 'dark' ? '#121212' : '#fff',
  textTransform: 'capitalize',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.mode !== 'dark' ? '#121212' : '#fff'}`,
  boxShadow: '0px 0px 0px transparent',
  '&:hover': {
    color: theme.palette.mode === 'dark' ? '#121212' : '#fff',
    backgroundColor: theme.palette.mode !== 'dark' ? '#121212' : '#fff',
    border: '1px solid #121212',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3),
    padding: theme.spacing(2, 18),
  },
}));

const BlankPageError = () => {
  const theme = useTheme();
  const { contactUsUrl } = useConfig();

  function reloadPage() {
    location.reload();
  }

  return (
    <LayoutStatusPageBox>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {theme.palette.mode !== 'dark' ? (
            <ImageWarning src={`/static/img/warning-2.svg`} />
          ) : (
            <ImageWarning src={`/static/img/warning-2-dark.svg`} />
          )}
          <LayoutStatusPageTitle>
            Oops! Something went wrong
          </LayoutStatusPageTitle>

          <LayoutStatusPageText sx={{ mb: 10 }}>
            <CustomerSupportLink
              target="_blank"
              href={contactUsUrl}
              variant="body2"
            >
              Contact Support
            </CustomerSupportLink>
          </LayoutStatusPageText>

          <BackHomeButton variant="outlined" onClick={reloadPage}>
            Reload Page
          </BackHomeButton>
        </Box>
      </Container>
    </LayoutStatusPageBox>
  );
};

export default BlankPageError;
